class WcVideo extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[wc-play-button]')?.addEventListener('click', this.playVideo.bind(this));
    this.querySelector('[wc-close-button]')?.addEventListener('click', this.pauseVideo.bind(this));
  }

  playVideo() {
    if (this.hasAttribute('wc-play-in-popup')) {
      this.classList.add('open-popup');
    }
    this.classList.add('playing');
    this.querySelector('video')?.play();
  }

  pauseVideo() {
    this.classList.remove('open-popup');
    this.classList.remove('playing');
    this.querySelector('video')?.pause();
  }
}
customElements.define('wc-video', WcVideo);